import { API, Auth } from 'aws-amplify';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useSwiper } from 'src/hooks/useSwiper';
import { RootState, useDispatch, useSelector } from 'src/store';
import { buttonsReset } from 'src/store/modules/buttons';
import { editUserCompany } from 'src/store/modules/client';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';
import { trackingReset } from 'src/store/modules/trackings';
import { getFontURL } from 'src/utils/getFontUrl';
import setInitValue from 'src/utils/setInitValue';
import { initTrackingValues } from '../TemplateTracking/SimpleCardModalTracking';

const initValue = {
  currentIndex: 0,
  bg: 'color',
  bgOpacity: { bgDimmed: 70 },
  bgImage: {
    multi_image: [
      'https://image.inappmessage.com/sample/default_image_9*16~1*1.webp'
    ]
  },
  bgColor: { background: '#ffffff' },
  radius: { multi_image: 0 },
  deeplink: {
    multi_image: ['https://www.inappmessage.com/']
  },
  btnText: {
    multi_left_button: ["Don't show again"],
    multi_right_button: ['Close']
  },
  btnFontSize: {
    multi_left_button: 0.875,
    multi_right_button: 0.875
  },
  btnFontWeight: {
    multi_left_button: 400,
    multi_right_button: 400
  },
  btnColor: {
    multi_left_button: '#000000',
    multi_right_button: '#000000'
  },
  btnBgColorR: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorG: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorB: { multi_left_button: 0, multi_right_button: 0 },
  btnBgColorA: { multi_left_button: 0, multi_right_button: 0 },
  btnFontFamily: {
    multi_left_button: 'Pretendard',
    multi_right_button: 'Pretendard'
  },
  btnAgain: {
    type: 'none',
    multi_left_button: "don't show"
  },
  button1: {
    multi_image: [],
    multi_left_button: [],
    multi_right_button: []
  },
  button2: {
    multi_image: [],
    multi_left_button: [],
    multi_right_button: []
  }
};
const SimpleCardModal = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);
  let currentIndex = useSelector(
    (state: RootState) => state.imageUpload.currentIndex
  );
  let bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  let radius = useSelector((state: RootState) => state.imageUpload.radius);
  let btnText = useSelector((state: RootState) => state.buttons.btnText);
  let btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  let btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  let btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  let btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  let bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {
        console.log('error');
      }
    }

    setInitValue(dispatch, { ...initValue, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());
      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());
      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);
  const style = `
    @font-face {
      font-family: "multiLeftButton";
      src: url(${multiLeftButtonFontURL});
    }
    @font-face {
      font-family: "multiRightButton";
      src: url(${multiRightButtonFontURL});
    }
    
    .root_view {
      width: 100%;
      height: 100%;
      position: relative;
      background: none;
      overflow: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .background {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }
    .modal-wrapper {
      position: relative;
      width: 314px;
      height: auto;
      display: flex;
      flex-direction: column;
    }
    .image-wrapper {
      width: 100%;
      max-height: 582px;
      height: auto;
      display: flex;        
    }
    .image {
      width: 100%;
      height: auto;
      object-fit: cover;
      object-position: top;
      border-radius: ${radius?.multi_image}px ${radius?.multi_image}px 0px 0px;
    }
    .btn-wrapper {
      width: 100%;
      height: 48px;
      padding: 0px 15px;
      background-color: ${bgColor?.background};
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .btn-wrapper button {
      border: 0;
      background-color: transparent;
    }
    .btn-wrapper .style01, .btn-wrapper .style02 {
      width: 100%;
      height: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      background-color: transparent;
    }
    .btn-wrapper .style01 {
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily.multi_left_button
          : 'multiLeftButton'
      };
      text-align: left;
    }
    .btn-wrapper .style02 {
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily.multi_right_button
          : 'multiRightButton'
      };
      text-align: right;
    }
    .swiper-container {
      width: 100%;
      height: 100%;
      max-height: 582px; 
      overflow: hidden;
      position: relative;							
    }
    .swiper-pagination {
      position: absolute;
      bottom: 10px;
      left: 0;
      right: 0;
      z-index: 10;
    }
    .swiper-pagination-bullet {
      background: #000000;
      opacity: 0.5;
    }
    .swiper-pagination-bullet-active {
      opacity: 1;
    }
    .swiper-wrapper {
      height: 100%;
      display: flex;
      align-items: flex-end;				
    }
    .swiper-slide {
      width: 100%;
      height: 100%; 
      display: flex;
      justify-content: center;
      align-items: center;				
    }
    .swiper-container-initialized .swiper-pagination {
      display: flex;
    }
    .swiper-container-initialized.swiper-container-horizontal.swiper-container-lock .swiper-pagination {
      display: none;
    }				
  `;

  const { swiperRef } = useSwiper();

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="modal-wrapper">
          <div className="swiper-container" ref={swiperRef}>
            <div className="swiper-wrapper">
              {bgImage?.multi_image?.map((imageUrl, index) => (
                <div className="swiper-slide" key={index}>
                  <div className="image-wrapper">
                    <img
                      className="image"
                      src={imageUrl}
                      alt={`modal-image-${index + 1}`}
                    />
                  </div>
                </div>
              ))}
            </div>
            <div className="swiper-pagination"></div>
          </div>
          <div className="btn-wrapper">
            <button className="style01">
              {btnText?.multi_left_button?.[currentIndex]}
            </button>
            <button className="style02">
              {btnText?.multi_right_button?.[currentIndex]}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SimpleCardModal;
